import Swiper, { Pagination } from 'swiper';

const SwiperGridBrands = function () {
  
  Swiper.use( Pagination );
  const els = document.querySelectorAll( '.swiper-grid-brands' );

  if ( Object.keys(els).length ) {
    els.forEach( function( el ){
      const pagination = el.querySelector( '.swiper-pagination');
      const swiper = new Swiper( el , {
        direction: 'horizontal',
        spaceBetween: 0,
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: 0,
        loop: true,
        preventClicks: true,
        pagination: {
          el: pagination,
          clickable: true
        }
      })
    });
  }
}

export default SwiperGridBrands;